import { ChartActionTypes, ChartActionUnion } from './actions';
import { ProgressBarChartState } from './state';

export const defaultState: ProgressBarChartState = {
  selectedTrancheId: undefined,
  combinedTranchesIds: [],
  isAllTranchesCombined: false,
  hoveredOrder: undefined
};

export function progressBarChartReducer(
  state: ProgressBarChartState = defaultState,
  action: ChartActionUnion
): ProgressBarChartState {
  switch (action && action.type) {
    case ChartActionTypes.SelectTranche:
      return { ...state, selectedTrancheId: action.payload };

    case ChartActionTypes.CombineTranche:
      return { ...state, combinedTranchesIds: action.payload };

    case ChartActionTypes.CombineAllTranches:
      return { ...state, isAllTranchesCombined: action.payload };

    case ChartActionTypes.HoverRecentOrder:
      return { ...state, hoveredOrder: action.payload };

    case ChartActionTypes.Reset:
      return defaultState;

    default:
      return state;
  }
}
